import serviceApi from "../apiClient";

export const getSubServiceApi = (parentId) => {
  return serviceApi.get(`service/subService/${parentId}`);
};
